<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 md8>
        <v-card class="elevation-2">
          <v-toolbar color="white">
            <v-toolbar-title>Signup for an account</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <small class="red--text">NOTE: Our admin will verify if you are a bona fide student or instructor of this institute.</small>
            <v-form>
              <v-container grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 md6>
                    <v-text-field
                      label="Username"
                      v-model="username"
                      required
                      :error-messages="userNameErrors"
                      @input="$v.username.$touch()"
                      @blur="$v.username.$touch()"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      label="Password"
                      v-model="password"
                      type="password"
                      required
                      :error-messages="passwordErrors"
                      @input="$v.password.$touch()"
                      @blur="$v.password.$touch()"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      label="Given Name"
                      v-model="givenName"
                      required
                      :error-messages="givenNameErrors"
                      @input="$v.givenName.$touch()"
                      @blur="$v.givenName.$touch()"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      label="Family Name"
                      v-model="familyName"
                      required
                      :error-messages="familyNameErrors"
                      @input="$v.familyName.$touch()"
                      @blur="$v.familyName.$touch()"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      label="Middle Name"
                      v-model="middleName"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md1>
                    <v-text-field
                      label="Ext."
                      v-model="extName"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md5>
                    <v-menu
                      ref="menu"
                      lazy
                      :close-on-content-click="false"
                      v-model="menu"
                      transition="scale-transition"
                      offset-y
                      full-width
                      :nudge-right="40"
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        label="Birthdate"
                        v-model="date"
                        prepend-icon="event"
                        readonly
                        required
                        :error-messages="dateErrors"
                        @input="$v.date.$touch()"
                        @blur="$v.date.$touch()"
                      ></v-text-field>
                      <v-date-picker
                        ref="picker"
                        v-model="date"
                        @change="save"  
                        :allowed-dates="allowedDates"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Address"
                      multi-line
                      rows="2"
                      v-model="address" 
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <p class="subheading">Gender:</p>
                    <v-radio-group v-model="gender" row>
                      <v-radio label="Male" :value="true" ></v-radio>
                      <v-radio label="Female" :value="false"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <!-- <v-flex xs12 md2>
                    <v-checkbox
                      label="Instructor?"
                      v-model="checkbox"
                    ></v-checkbox>
                  </v-flex> -->
                  <v-flex xs12 md6>
                    <v-text-field
                      label="Contact Number"
                      mask="###########"
                      v-model="contactNo"
                      :error-messages="contactNoErrors"
                      @input="$v.contactNo.$touch()"
                      @blur="$v.contactNo.$touch()"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions >
            <v-btn class="mb-2" block round color="green darken-1" dark @click="signUp">Sign up</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import VueNotifications from 'vue-notifications'
import axios from 'axios'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
export default {
  mixins: [validationMixin],
  validations: {
    date: {
      required
    },
    username: {
      required
    },
    password: {
      required
    },
    givenName: {
      required
    },
    familyName: {
      required
    },
    contactNo: {
      required
    }
  },
  data(){
    return {
      date: null,
      gender: true,
      menu: false,
      checkbox: false,
      username: '',
      password: '',
      givenName: '',
      familyName: '',
      middleName: '',
      extName: '',
      address: '',
      contactNo: ''
    }
  },
  watch: {
    menu (val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },
  methods: {
    async signUp(){
      let { username, password, givenName, familyName, middleName, extName, address, contactNo, date, checkbox, gender } = this
      this.$v.$touch()
      if(!this.$v.$error){
        this.$Progress.start()
        try{
          let response = await axios.post('/api/auth/signup', {
            username, 
            password,
            isMale: gender,
            family_name: familyName,
            given_name: givenName,
            middle_name: middleName,
            ext_name: extName,
            address,
            birthday: date,
            contact_number: contactNo,
            // user_role: checkbox ? 1 : 2
          }, { headers: { 'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}` } })
          this.showSuccessMsg({ title: 'Success!', message: 'Signup successful! Please wait for this account to be verified.' })
          this.$Progress.finish()
          this.clearFields()
          this.$router.push('/')
        }catch(e){
          console.log(e)
          this.showErrorMsg({ title: e.response.statusText, message: 'Signup not successful.' })
          this.$Progress.fail()
        }
      }
    },
    save (date) {
      this.$refs.menu.save(date)
    },
    allowedDates(val){
      return new Date().toISOString().substr(0,10) >= val
    },
    clearFields(){
      this.date = null,
      this.menu = false,
      this.checkbox = false,
      this.username = '',
      this.password = '',
      this.givenName = '',
      this.familyName = '',
      this.middleName = '',
      this.extName = '',
      this.address = '',
      this.contactNo = ''
      this.gender = true
    }
  },
  computed: {
    dateErrors(){
      const errors = []
      if(!this.$v.date.$dirty) return errors
      !this.$v.date.required && errors.push('Birthdate is required')
      return errors
    },
    userNameErrors(){
      const errors = []
      if(!this.$v.username.$dirty) return errors
      !this.$v.username.required && errors.push('Username is required')
      return errors
    },
    passwordErrors(){
      const errors = []
      if(!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Password is required')
      return errors
    },
    givenNameErrors(){
      const errors = []
      if(!this.$v.givenName.$dirty) return errors
      !this.$v.givenName.required && errors.push('Given name is required')
      return errors
    },
    familyNameErrors(){
      const errors = []
      if(!this.$v.familyName.$dirty) return errors
      !this.$v.familyName.required && errors.push('Family name is required')
      return errors
    },
    // middleNameErrors(){
    //   const errors = []
    //   if(!this.$v.middleName.$dirty) return errors
    //   !this.$v.middleName.required && errors.push('Middle name is required')
    //   return errors
    // },
    // addressErrors(){
    //   const errors = []
    //   if(!this.$v.address.$dirty) return errors
    //   !this.$v.address.required && errors.push('Address is required')
    //   return errors
    // },
    contactNoErrors(){
      const errors = []
      if(!this.$v.contactNo.$dirty) return errors
      !this.$v.contactNo.required && errors.push('Contact number is required')
      return errors
    }
  },
  notifications: {
    showSuccessMsg: { type: VueNotifications.types.success },
    showErrorMsg: { type: VueNotifications.types.error }
  }
}
</script>

<style>
.swal-title,
.swal-text,
.swal-button{
  font-family: 'Roboto',sans-serif;
}

.swal-button{
  background-color: #43a047;
}
</style>


// WEBPACK FOOTER //
// src/components/HomePage/Signup.vue